import i18n from '@/lang/i18n'

export const VIEWS_ACTIONS = {
    SAVE: 'SAVE',
    REMOVE: 'REMOVE',
    DUPLICATE: 'DUPLICATE',
    EDIT: 'EDIT',
    DEFAULT: 'DEFAULT',
}

export const VIEWS_DEFAULT_ID = -1
export const VIEWS_DEFAULT = [{
    id: VIEWS_DEFAULT_ID,
    data: {
        label: 'Default',
        filters: {},
    },
}]

export const VIEWS_OPTIONS = [{
    key: VIEWS_ACTIONS.SAVE,
    label: i18n.t('actions.save'),
    icon: 'save',
}, {
    key: VIEWS_ACTIONS.REMOVE,
    label: i18n.t('actions.remove'),
    icon: 'trash',
}, {
    key: VIEWS_ACTIONS.DUPLICATE,
    label: i18n.t('actions.duplicate'),
    icon: 'copy',
}, {
    key: VIEWS_ACTIONS.EDIT,
    label: i18n.t('actions.editName'),
    icon: 'edit',
}, {
    key: VIEWS_ACTIONS.DEFAULT,
    label: i18n.t('actions.default'),
    icon: 'check-square',
}]

export default {
    VIEWS_ACTIONS,
    VIEWS_DEFAULT_ID,
    VIEWS_DEFAULT,
}
